import {createAction, props} from "@ngrx/store"
import { Aplicacion, Usuario, UsuarioRedux } from 'src/app/models/usuario.model';

export const login = createAction(
    '[AUTH] Login', props<{nombreUsuario:string; claveUsuario:string, returnUrl:string}>()
);

export const loginSuccess = createAction(
    
    '[AUTH] Login Success', props<{user:UsuarioRedux, access_token:string, token_type:string}>()
);

export const loginError = createAction(
    '[AUTH] Login Error', props<{payload: any}>()
);

export const logout = createAction(
    '[AUTH] Logout'
);

export const logoutSuccess = createAction(
    '[AUTH] Logout Success'
);

export const logoutError = createAction(
    '[AUTH] Logout Error', props<{payload: any}>()
);

export const addAplicacion = createAction(
    '[REDUX] Add Aplicacion to User', props<{idSprAplicacion:number, idSprRol:number}>()
);

export const addAplicacionSuccess = createAction(
    '[REDUX] Add Aplicacion to User Success', props<{aplicacion:Aplicacion, idSprRol:number}>()
);

export const addAplicacionError = createAction(
    '[REDUX] Add Aplicacion to User Error', props<{payload: any}>()
);